<h3 mat-dialog-title>{{getTitle()}}</h3>

<div mat-dialog-content class="content">
  <!-- Choice of refund method -->
  @if (!showChooseTerminal && !transactionStarted && !transactionFinished && data.refund) {
    <mat-button-toggle-group class="toggle"
      #group="matButtonToggleGroup" (change)="changeRefundMethod(group.value)" value="card">
      <mat-button-toggle value="card">Kort</mat-button-toggle>
      <mat-button-toggle value="bank">Banköverföring</mat-button-toggle>
    </mat-button-toggle-group>
  }

  @if (data.refund && !transactionStarted && !showChooseTerminal && !transactionFinished) {
    <p>Max summa för
    återbetalning: {{data.maxRefund}} kr</p>
  }

  @if (!showChooseTerminal && !transactionStarted && !transactionFinished && !data.refund) {
    <div class="input">
      <mat-form-field>
        <mat-label>Belopp</mat-label>
        <input matInput max="{{data.order.amountToPay}}" min="0" [formControl]="paymentControl">
        <mat-error>Max belopp {{data.order.amountToPay}} kr</mat-error>
      </mat-form-field>
    </div>
  }

  @if (!showChooseTerminal && !transactionStarted && !transactionFinished && data.refund) {
    <div class="input">
      <mat-form-field>
        <mat-label>Belopp</mat-label>
        <input matInput max="{{data.maxRefund}}" min="0" [formControl]="refundControl">
        <mat-error>Max belopp {{data.maxRefund}} kr</mat-error>
      </mat-form-field>
    </div>
  }

  @if (!showChooseTerminal && !transactionStarted && !transactionFinished && data.refund) {
    <div class="input">
      <mat-form-field>
        <mat-label>Anledning till återköp</mat-label>
        <input matInput type="text" [formControl]="commentControl" required>
        <mat-error>Kommentar krävs</mat-error>
      </mat-form-field>
    </div>
  }

  @if (showChooseTerminal && terminalsFetched) {
    <div class="selectTerminal">
      <mat-radio-group [formControl]="form">
        @for (terminal of availTerminals; track terminal) {
          <mat-radio-button [value]="terminal"
          [checked]="terminal.terminalId === selectedTerminal!.terminalId">{{terminal.name}}</mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }

  <!-- Display status message -->
  @if (transactionStarted) {
    <div class="paymentStatus">
      <app-pax-payment-status (finished)="finalStatus($event)"></app-pax-payment-status>
    </div>
  }

  <div mat-dialog-actions class="dialogActions">
    <!-- Cancel button -->
    @if (showCancelBtn()) {
      <button mat-button (click)="cancelPayment(form.value?.terminalId!)"
      >Avbryt</button>
    }

    <!-- Close button -->
    @if (!transactionStarted && !transactionFinished) {
      <button mat-button (click)="closeDialog()">Stäng</button>
    }

    <!-- Go to select terminal -->
    @if (!showChooseTerminal && !transactionStarted  && paymentMethod === 'card') {
      <button mat-button (click)="chooseTerminal()"
        [disabled]="refund && !commentControl.value">
        Nästa
      </button>
    }

    <!-- Handle refund through bank transfer -->
    @if (!showChooseTerminal && !transactionStarted && !transactionFinished && paymentMethod === 'bank') {
      <button mat-button (click)="bankRefund()"
        [disabled]="refund && !commentControl.value">
        Genomför återbetalning
      </button>
    }

    <!-- Start payment -->
    @if (showChooseTerminal) {
      <button mat-button (click)="startPayment(form.value!)" [disabled]="!selectedTerminal"
        disabled>
        Nästa
      </button>
    }

    @if (transactionFinished) {
      <button mat-button (click)="skipPrint()">Stäng</button>
    }
    @if (transactionFinished && paymentMethod === 'card') {
      <button mat-button class="button"
      (click)="receiptPrint()">Skriv ut kvitto</button>
    }
  </div>
</div>